import {
  UploadedDocumentDocumentType,
  UploadedDocumentInfoDocumentType,
} from '@urbanx/agx.campaigns.client';
import type {
  DocumentGroup,
  StaffContractDetailModel,
  UploadedDocument,
  UploadedDocumentInfo,
} from '@urbanx/agx.campaigns.client';

const exchangeDocumentTypes = [
  { type: UploadedDocumentDocumentType.SalesAdvice, title: 'Sales Advice' },
  { type: UploadedDocumentDocumentType.ExchangeLetter, title: 'Exchange Letter' },
  { type: UploadedDocumentDocumentType.SignedContract, title: 'Signed Contract' },
  { type: UploadedDocumentDocumentType.Miscellaneous, title: 'Additional Documents' },
  {
    type: UploadedDocumentDocumentType.SalesContractAnnexure,
    title: 'Sales Contract Annexure',
  },
];

const getDocumentKey = (document: UploadedDocument) =>
  [
    document.containerName,
    document.documentType,
    document.containerFilePath,
    document.documentId,
    document.fileName,
  ]
    .filter(Boolean)
    .join('/');

const toUploadedDocumentInfo = (document: UploadedDocument): UploadedDocumentInfo => ({
  ...document,
  title: exchangeDocumentTypes.find(({ type }) => type === document.documentType)?.title,
  documentType: document.documentType as unknown as UploadedDocumentInfoDocumentType,
});

export const getExchangeTaskDocumentGroups = (
  contract?: StaffContractDetailModel
): DocumentGroup[] => {
  const seen = new Set<string>();
  const documents = [
    ...Object.values(contract?.contractDocuments ?? {}),
    ...(contract?.documents ?? []),
  ]
    .filter((document): document is UploadedDocument => !!document?.containerFilePath)
    .filter((document) => exchangeDocumentTypes.some(({ type }) => type === document.documentType))
    .filter((document) => {
      const key = getDocumentKey(document);
      if (seen.has(key)) return false;

      seen.add(key);
      return true;
    })
    .sort(
      (left, right) =>
        exchangeDocumentTypes.findIndex(({ type }) => type === left.documentType) -
        exchangeDocumentTypes.findIndex(({ type }) => type === right.documentType)
    )
    .map(toUploadedDocumentInfo);

  return documents.length > 0
    ? [
        {
          title: contract?.contractName ?? 'Contract Documents',
          documents,
        },
      ]
    : [];
};
